import React from "react";

import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Radium, { StyleRoot } from "radium";
import { fadeInRightBig } from "react-animations";
import { Img } from "react-image";

import buildingConcept from "./../../assets/images/building-idilio-vistania-gs.png";
import "./sass/index.scss";

const styles = {
  fadeInRightBig: {
    animation: "x .5s",
    animationName: Radium.keyframes(fadeInRightBig, "fadeInRightBig"),
  },
  fadeInRightBig2: {
    animation: "x 1s",
    animationName: Radium.keyframes(fadeInRightBig, "fadeInRightBig"),
  },
};

class ConceptIdilioVistania extends React.Component<any, any> {
  render() {
    return (
      <div className="cont-concept-project">
        <div className="con-text">
          <StyleRoot>
            <div style={styles.fadeInRightBig}>
              <div className="iconPlus" />
              <p>
                Proyecto que nace entre la historia y la modernidad: elevándose
                en armonía con su entorno, respetando el espíritu de la zona
                monumental. Su arquitectura escalonada dialoga con la tradición,
                mientras proyecta una visión contemporánea, donde cada espacio
                ha sido pensado para el confort, la luz y el silencio. Los
                materiales nobles, la vegetación y la composición volumétrica se
                entrelazan para crear una experiencia arquitectónica que se
                siente, se habita y se prolonga. Un refugio de equilibrio,
                calidez y permanencia en el tiempo.
              </p>
            </div>
          </StyleRoot>
        </div>
        <div className="cont-image">
          <StyleRoot>
            <div style={styles.fadeInRightBig2}>
              <Img
                src={buildingConcept}
                loader={
                  <div className="loader">
                    <FontAwesomeIcon icon={faSpinner} pulse />
                  </div>
                }
                alt=""
              />
            </div>
          </StyleRoot>
        </div>
      </div>
    );
  }
}

export default ConceptIdilioVistania;
